<template>
    <div class="menu" v-if="Apellido">
        <el-row style="min-height:28px">
            <div class="boton"><router-link :to="{ name: 'home' }"              >Inicio             </router-link></div>
            
            <div class="boton"><router-link :to="{ name: 'capacitaciones' }"    >Capacitaciones     </router-link></div>
            <el-dropdown style="float:right">
                <span class="el-dropdown-link">

                    <i  v-if="!Notificado_Alerta" class="fas fa-exclamation-circle  mialerticon"></i>
                    {{ Nombre }} {{ Apellido }} <i class="el-icon-arrow-down el-icon--right"></i>&nbsp;&nbsp;
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item><router-link :to="{ name: 'datos' }"      >  Datos Personales   </router-link></el-dropdown-item>
                    <el-dropdown-item><router-link :to="{ name: 'pass' }"       >Cambiar Contraseña </router-link></el-dropdown-item>
                    <el-dropdown-item divided><a @click="Logout()"              >Salir              </a></el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </el-row>
    </div>
</template>



<script>
    import axios from 'axios';

    export default
    {   name: 'Menu',
        data()
        {   return {
                Apellido:   '',
                Nombre:     '',
                Notificado_Alerta: 'true',               
                };
        },



        methods:
        {   Logout()
            {   var params  = 'tkn=' + this.$cookies.get('PDTK');
                var headers = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');

                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/lg_o.php', params, {headers: headers})
                    .then(response => {
                        /*const datos     = response.data;*/
                        this.$cookies.remove("PDTK");
                        this.$cookies.remove("PDVisitas");
                        window.location.href = '/';
                    })
                   /* .catch(e => {})*/
            }
        },



        beforeMount()
        {   if(this.$route.name=='login')
            {   this.$cookies.remove("PDTK");
                this.$cookies.remove("PDVisitas");  
            }
            else
            {   var params  = 'tkn=' + this.$cookies.get('PDTK');
                var headers = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');
                
                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/doc_menu.php', params, {headers: headers})
                    .then(response => {
                        const datos     = response.data
                        this.Nombre     = datos['personales']['Nombre'];
                        this.Apellido   = datos['personales']['Apellido'];
                        //this.Notificado_Alerta = datos[`Notificado`];
                    })
                    /*.catch(e => {})*/
            }
          
        }
    };
</script>



<style>
    .menu
    {   width: 100%;
        min-height: 28px;
        background: rgba(255, 255, 255, 0.5);
        margin-bottom: 40px;
        padding: 15px 0px 5px 0px;
        -webkit-transition: all 300ms ease-in-out;
        -moz-transition: all 300ms ease-in-out;
        -o-transition: all 300ms ease-in-out;
        -ms-transition: all 300ms ease-in-out;
        transition: all 300ms ease-in-out;
    }

    .boton
    {   position: relative;
        float: left;
    }
    .el-dropdown
    {   font-weight: bold;
        text-decoration: none;
        color: #0098C8;
        cursor: pointer;
    }

    .menu div div a
    {   -webkit-transition: all 300ms ease-in-out;
        -moz-transition: all 300ms ease-in-out;
        -o-transition: all 300ms ease-in-out;
        -ms-transition: all 300ms ease-in-out;
        transition: all 300ms ease-in-out;
        font-weight: bold;
        text-decoration: none;
        font-size: large;
        padding: 15px 20px 5px 20px;
        color: #0098C8;
    }
    .menu div div:hover a
    {   -webkit-transition: all 300ms ease-in-out;
        -moz-transition: all 300ms ease-in-out;
        -o-transition: all 300ms ease-in-out;
        -ms-transition: all 300ms ease-in-out;
        transition: all 300ms ease-in-out;
        font-size: x-large;
        background: rgba(255, 255, 255, 0.75);
        color: #0096C7;
    }
    .mialerticon
    {
        color: red!important;
    }
    .campananotificacion
     {
       
       animation: cambiacolor 4s infinite;
     }
     @keyframes cambiacolor
     {
        0% {color: inherit; transform: rotateZ(10deg)}
        50% {color: red;transform: rotateZ(-10deg)}
        100% {color: inherit; transform: rotateZ(10deg)}


     }
    @media (max-width:767px)
    {	.menu div div
        {   width: 100%;
            border-bottom: 2px solid #0098C8;
            margin-bottom: 10px;
        }
    }
</style>

